import React from 'react';
import { Countdown } from './Countdown';
import { Eyebrow } from './Eyebrow';
const CLAIMED_PERCENT = 68;
export function LaunchUrgency() {
  return <section aria-labelledby="urgency-heading" className="border-y border-ember/40 bg-ember-dark py-12 sm:py-20" data-id="element-224" data-mp="mgoigxvaj96j">
      <div className="mx-auto grid max-w-shell gap-10 px-5 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-225" data-mp="117nj9mpvwtfk">
        <div data-id="element-226" data-mp="8h5mf3fr7oal">
          <Eyebrow data-id="element-227" data-mp="8gne38fthjmb">Oferta ograniczona czasowo</Eyebrow>
          <h2 id="urgency-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-5xl" data-id="element-228" data-mp="8hf8ifxohbb0">
            Cena premierowa <span className="text-amber" data-id="element-229" data-mp="hiwn1tvft4xl">wygasa za</span>
          </h2>
          <div className="mt-6" data-id="element-230" data-mp="dgi4zbzle97d">
            <Countdown initialSeconds={86347} data-id="element-231" data-mp="dfgtj6enzkp4" />
          </div>
          <p className="mt-6 max-w-md text-sm text-cream-muted" data-id="element-232" data-mp="1swqrfdkw6nxh">
            Cena premierowa kończy się dziś. Potem wraca do $97.
          </p>
        </div>
        <div className="rounded-2xl border border-ember/40 bg-night-950 p-5 sm:p-7" data-id="element-233" data-mp="1ov5ho13nmpri">
          <div className="flex items-baseline justify-between gap-4" data-id="element-234" data-mp="1yi55e1zt8vlu">
            <span className="text-[10px] font-semibold uppercase tracking-label text-cream-muted sm:text-[11px]" data-id="element-235" data-mp="23gyl812kkyp6">
              Ograniczona dostępność &mdash; tylko dziś
            </span>
            <span className="font-display text-3xl leading-none text-amber" data-id="element-236" data-mp="2ciy3ewpbm8tp">{CLAIMED_PERCENT}%</span>
          </div>
          <div className="mt-5 h-2.5 w-full overflow-hidden rounded-full bg-night-600" role="progressbar" aria-valuenow={CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Wykorzystana pula premierowa" data-id="element-237" data-mp="1fsylibna5xyg">
            <div className="h-full rounded-full bg-amber" style={{
            width: `${CLAIMED_PERCENT}%`
          }} data-id="element-238" data-mp="1tklr52344itw" />
          </div>
          <p className="mt-4 text-xs uppercase tracking-label text-cream-muted" data-id="element-239" data-mp="w3n21ski5nii">Wykorzystano</p>
        </div>
      </div>
    </section>;
}